<template>
    <div class="recipes-filter">
        <b-container>
            <div class="content-container">
                <div class="header-container">
                    <b-button
                        variant="link"
                        class="toggle-button"
                        v-b-toggle="'recipe-filters'"
                        v-test:toggleButton
                    >
                        <span
                            class="title"
                            v-test:title
                        >
                            {{ $snippet('categories', 'categories') }}
                        </span>

                        <app-icon
                            name="chevron_up"
                            v-test:icon
                        />
                    </b-button>
                </div>

                <b-collapse
                    id="recipe-filters"
                    class="filter-panel-collapse"
                    v-model="visible"
                >
                    <div class="filter-panel-container">
                        <div class="filter-panel">
                            <b-form @submit.prevent="handleSubmit" v-test:form>
                                <b-form-group>
                                    <b-form-checkbox-group v-model="selected">
                                        <b-form-checkbox
                                            v-for="category in categories"
                                            :key="category.text"
                                            :value="category.value"
                                        >
                                            <span v-html="apostrophise(category.text)" />
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </b-form-group>

                                <div class="btn-container">
                                    <b-button
                                        variant="primary"
                                        type="submit"
                                        class="apply-btn"
                                        block
                                        v-test:applyBtn
                                    >
                                        {{ $snippet('apply', 'apply') }}
                                    </b-button>
                                </div>
                            </b-form>
                        </div>
                    </div>
                </b-collapse>
            </div>
        </b-container>
    </div>
</template>

<script>
    import { BCollapse, BForm, BFormGroup, VBToggle, BFormCheckboxGroup, BFormCheckbox } from 'bootstrap-vue';

    export default {
        name: 'recipes-filter',

        components: { BForm, BFormGroup, BCollapse, BFormCheckboxGroup, BFormCheckbox },

        directives: {
            'b-toggle': VBToggle,
        },

        props: {
            value: {
                type: Array,
                default: () => ([]),
            },

            categories: {
                type: Array,
                default: () => ([]),
            },
        },

        data() {
            return {
                visible: false,
                selected: [],
            };
        },

        watch: {
            value: {
                immediate: true,
                handler(value) {
                    this.selected = [
                        ...value,
                    ];
                },
            },
        },

        methods: {
            /**
             * When the form is submitted, send an event up
             * with the selected categories and close the dropdown.
             */
            handleSubmit() {
                this.$emit('update', this.selected);

                this.visible = false;
            },

            /**
             * Replace ' with pink apostrophe.
             *
             * @param {string} text
             * @returns {string}
             */
            apostrophise(text) {
                return text.replace('\'', '<span class="itsu-pink">\'</span>');
            },
        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep {
        @import "~bootstrap/scss/custom-forms";
    }

    .content-container {
        position: relative;
        border-bottom: 2px solid #000000;
    }

    .header-container {
        display: flex;
        justify-content: flex-end;
    }

    .filter-panel-collapse {
        position: absolute;
        right: 0;
        top: 100%;
        z-index: 2;
        width: 300px;
        max-width: 100%;
    }

    .filter-panel-container {
        border: solid 2px primary-palette(1);
        border-bottom-left-radius: 50px;
        border-bottom-right-radius: 50px;
        padding: 15px 20px;
        background-color: #ffffff;

        @include media-breakpoint-up(md) {
            padding: 25px 45px;
        }
    }

    .toggle-button {
        border-radius: 0;
        white-space: nowrap;
        display: flex;
        align-items: center;

        &.collapsed {
            .app-icon {
                transform: rotate(180deg);
            }
        }
    }

    .title {
        margin-right: 5px;
    }

    ::v-deep .custom-control {
        padding-left: 0;
        margin: 0;
        display: flex;
    }

    ::v-deep .custom-control-label {
        width: 100%;
        padding-right: 40px;
        font-weight: 700;
        padding-top: 8px;
        padding-bottom: 8px;

        &::before,
        &::after {
            left: unset;
            right: 0;
            top: 4px;
        }
    }

    .btn-container {
        padding-top: 20px;
    }
</style>
